<template>
  <div :class="['retailer-search-result-fi', theme ? `retailer-search-result-fi--${theme}` : null]">
    <div class="retailer-search-result-fi__items">
      <retailer-search-result-item-fi
        v-for="item in slicedRetailers"
        :key="item.Retailer.RetailerId || 'null'"
        :data="item"
        :show-stock
        :partner-type-logo
        :theme
        @clicked="(val) => $emit('clicked', val)"
      />
    </div>

    <div
      v-if="totalItems > itemsPerPage"
      class="retailer-search-result-fi__pagination"
    >
      <pagination-progress-bar
        :pagination-page="currentPage"
        :pagination-total="totalPages"
        :progressbar-value="percentagePagination"
        @loadmore="nextPage"
      >
        <span>{{
          $dict.get('dealer-Locator.Pagination', [String(currentItem), String(totalItems)])
        }}</span>
      </pagination-progress-bar>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PaginationProgressBar } from 'atoms';
import { computed, ref } from 'vue';

import RetailerSearchResultItemFi from './retailer-search-result-item-fi/RetailerSearchResultItemFi.vue';

defineOptions({ name: 'RetailerSearchResultFi' });

const props = withDefaults(
  defineProps<{
    retailers: { isStocked: boolean | null; Retailer: { RetailerId: string | null } }[];
    showStock?: boolean;
    partnerTypeLogo?: object | null;
    theme?: string | null;
  }>(),
  {
    showStock: false,
    partnerTypeLogo: null,
    theme: null,
  },
);

defineEmits<{
  clicked: [val: any];
}>();

const itemsPerPage = 10;
const currentPage = ref(1);

const totalItems = computed(() => props.retailers.length);
const totalPages = computed(() => Math.ceil(totalItems.value / itemsPerPage));
const percentagePagination = computed(
  () => ((currentPage.value * itemsPerPage) / (totalPages.value * itemsPerPage)) * 100,
);
const currentItem = computed(() =>
  Math.min(currentPage.value * itemsPerPage, props.retailers.length),
);
const slicedRetailers = computed(() => {
  const nonNullRetailers = props.retailers.filter((retailer) => retailer !== null);
  const lastItem = Math.min(currentPage.value * itemsPerPage, nonNullRetailers.length);
  return nonNullRetailers.slice(0, lastItem);
});

const nextPage = () => {
  currentPage.value += 1;
};
</script>

<style scoped src="./retailer-search-result-fi" />
